let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bnDM4")).then(() => parcelRequire('k16yv'));